import { Button } from '@brightdrop/bd-ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { translateText } from '~/common/components/TranslatedLabel/TranslatedLabel';
import { AppRoutePaths } from '~/common/models/route.model';
import InvalidInviteTemplate from '~/routes/invites/invalidInvitePages/InvalidInviteTemplate';

const ExpiredInvitePage = (): JSX.Element => {
  // Subscribe to i18n so imperative `translateText(...)` updates after locale changes.
  useTranslation(['common']);
  const navigate = useNavigate();

  return (
    <InvalidInviteTemplate
      header={translateText('common:inviteExpired')}
      message={translateText('common:invitationExpiredMessage')}
      action={
        <Button
          variant="button-link"
          onClick={() => navigate(AppRoutePaths.LOGOUT)}
          data-testid="expired-invite-sign-out-button"
        >
          {translateText('common:header.signOut')}
        </Button>
      }
    />
  );
};

export default ExpiredInvitePage;
